// src/api/CrystalsApi.js

import apiClient from './apiClient';

const inventoryClient = apiClient('');

const CrystalsApi = {
    /**
     * Получить один тип гема по ID
     * @param {number} id
     * @returns {Promise<GemType>}
     */
    async getGemById(id) {
        try {
            const response = await inventoryClient.get(`/gem-types/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Ошибка при получении гема с ID ${id}:`, error);
            throw error;
        }
    },

    /**
     * Получить все гемы, отсортированные по position ASC
     * @returns {Promise<GemType[]>}
     */
    async getAllGems() {
        try {
            const response = await inventoryClient.get('/gem-types');
            return response.data;
        } catch (error) {
            console.error('Ошибка при получении списка типов гемов:', error);
            throw error;
        }
    },

    /**
     * GET /gems/positions?list=1,2,3
     */
    async getGemsByPositions(positions) {
        const listParam = positions.join(',');
        const response = await inventoryClient.get('/gem-types/positions', {
            params: { list: listParam },
        });
        // теперь точно массив в response.data
        return Array.isArray(response.data) ? response.data : response.data.gems || [];
    },
};

export default CrystalsApi;
